import { ApolloError, useLazyQuery } from '@apollo/client'
import { t } from '@lingui/core/macro'
import type {
  CargoInput,
  PodeAdicionarCargoQuery,
  PodeAdicionarCargoQueryVariables
} from '@/core/types/graphql'
import { PODE_ADICIONAR_CARGO_QUERY } from '../data/cargos'
import { snackbar } from '@/core/utils/snackbar'
import { useCallback } from 'react'

export const usePodeAdicionarCargo = () => {
  const [runValidation, { loading, error }] = useLazyQuery<
    PodeAdicionarCargoQuery,
    PodeAdicionarCargoQueryVariables
  >(PODE_ADICIONAR_CARGO_QUERY)

  const validate = useCallback(
    async (
      cargoAdicionado: CargoInput,
      cargosExistentes: CargoInput[]
    ): Promise<boolean> => {
      try {
        const { data } = await runValidation({
          variables: {
            podeAdicionarCargoInput: {
              cargoAdicionadoInput: cargoAdicionado,
              cargosInputs: cargosExistentes
            }
          }
        })
        if (data?.podeAdicionarCargo) return true
        snackbar.show(
          'error',
          t`Não foi possível adicionar o cargo. Verifique se a data de início do cargo é posterior à data de início dos cargos já selecionados.`
        )
        return false
      } catch {
        return false
      }
    },
    [runValidation]
  )

  return { validate, loading, error: error as ApolloError | undefined }
}
